import { DateTime } from 'luxon';
import { TGetSalesReportsResponseRowsItem } from 'redux/reducers/reports/types';
import { EIconButtons } from 'services/constants/iconsTypes';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { durationDates } from 'utils/durationDates';

const formatReportingPeriod = (item: TGetSalesReportsResponseRowsItem) => {
	const intervalStringArray = durationDates(item.duration ?? '');
	const start = intervalStringArray[0].slice(0, 10);

	if (intervalStringArray.length === 1) return `to ${start}`;

	const end = DateTime.fromISO(intervalStringArray[1].slice(0, 10))
		.minus({ days: 1 })
		.toFormat('yyyy-MM-dd');
	return `${start} - ${end}`;
};

export const tableStructure: TTableStructure<
	keyof TGetSalesReportsResponseRowsItem,
	TGetSalesReportsResponseRowsItem
>[] = [
	{
		name: 'Id',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Reporting Period',
		selector: 'duration',
		value: formatReportingPeriod,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Download report',
		selector: 'actions' as keyof TGetSalesReportsResponseRowsItem,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.CENTER,
		buttons: [
			{
				name: 'Download report',
				label: '.csv',
				icon: EIconButtons.DOWNLOAD,
				iconWithName: true,
			},
		],
	},
];
